import httpClient from "@/common/service/HttpClient";
import { endPoints } from "@/constants/apiSetting";
const ReportService = {
  getLeaveBalance(obj) {
    return httpClient.post(endPoints.getLeaveBalance, obj);
  },
  getStaffList(obj) {
    return httpClient.post(endPoints.reportUserList, obj);
  },
  getStaffAttendance(obj) {
    return httpClient.post(endPoints.getStaffAttendance, obj);
  },
  getStaffMonthlyLeaveBalance(obj) {
    return httpClient.post(endPoints.getStaffMonthlyLeaveBalance, obj);
  },
  sendEmail(obj) {
    return httpClient.post(endPoints.sendEmail, obj);
  },
  getStaffOutdoorworkAllowance(obj) {
    return httpClient.post(endPoints.getStaffOutdoorworkAllowance, obj);
  },
  updateStaffAttendance(obj) {
    return httpClient.post(endPoints.updateStaffAttendance, obj);
  },
  IRDList(obj) {
    return httpClient.post(endPoints.IRDList, obj);
  },
  expToXml(obj) {
    return httpClient.post(endPoints.expToXml, obj);
  },
  printIRD(obj) {
    return httpClient.post(endPoints.printIRD, obj);
  },
  printIR56M2(obj) {
    return httpClient.post(endPoints.printIR56M2, obj);
  }
};

export default ReportService;



// WEBPACK FOOTER //
// ./src/service/ReportService.js